import { createPortal } from 'react-dom'
import React, { useEffect, useState } from 'react'
import { WithChildren } from '@viveaesthetics/elemy-shared-core'
import { Flex, useMediaQuery } from '@viveaesthetics/shared'

import { SubheaderContent } from './styles'

export const Subheader = ({ children }: WithChildren) => {
  const [headerElement, setHeaderElement] = useState<HTMLElement | null>(null)
  const { isDesktop } = useMediaQuery()

  useEffect(() => {
    setHeaderElement(document.getElementById('header-content'))
  }, [])

  return headerElement ? (
    createPortal(
      <SubheaderContent
        $padding={
          isDesktop
            ? ['spacing4', 'spacing24', 'spacing8', 'spacing24']
            : ['spacing4', 'spacing16', 'spacing8', 'spacing16']
        }
      >
        <Flex $space="spacing8">{children}</Flex>
      </SubheaderContent>,
      headerElement
    )
  ) : (
    <></>
  )
}
